import { useIsMobile } from 'hooks/useIsMobile';
import { NotAvailableOnThisDevice } from './NotAvailableOnThisDevice';

/**
 * Renders children above the mobile breakpoint and the "not available" message otherwise.
 * Children are not mounted on mobile, so their queries do not run.
 */
export const DesktopOnly = ({ children }: { children: JSX.Element }): JSX.Element => {
  const isMobile = useIsMobile();
  return isMobile ? <NotAvailableOnThisDevice /> : children;
};
